// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import { useAuth } from '../auth/AuthContext';
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Container,
//   Paper,
//   MenuItem,
//   CircularProgress
// } from '@mui/material';

// const RegisterLearner = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const auth = useAuth();
//   const schoolId = location.state?.schoolId || auth.schoolId;

//   const [formData, setFormData] = useState({
//     fullName: '',
//     dateOfBirth: '',
//     className: 'PP1',
//     admissionNumber: '',
//     birthCertificateNumber: '',
//     gender: 'M',
//     parentName: '',
//     parentContact: '',
//     parentEmail: '',
//     parentId: ''
//   });
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState('');

//   const classes = [
//     'PP1', 'PP2', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5',
//     'Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12',
//   ];

//   useEffect(() => {
//     if (!schoolId) {
//       setError('School ID is missing. Please log in again.');
//     }
//   }, [schoolId]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!schoolId) {
//       setError('School ID is missing. Please log in again.');
//       return;
//     }
  
//     setIsLoading(true);
//     setError('');
  
//     try {
//       const learnerData = {
//         fullName: formData.fullName,
//         dateOfBirth: new Date(formData.dateOfBirth).toISOString().split('T')[0],
//         class: formData.className,  // Changed from className to class
//         admissionNumber: formData.admissionNumber,
//         birthCertificateNumber: formData.birthCertificateNumber,
//         gender: formData.gender,
//         parentName: formData.parentName,
//         parentContact: formData.parentContact,
//         parentEmail: formData.parentEmail,
//         parentId: formData.parentId || null,  // Ensure this is null if empty
//         schoolId,
//       };
  
//       const response = await axios.post('https://kidsm.vercel.app/api/schools/register-learner', learnerData);
//       if (response.status === 201) {
//         alert('Learner registered successfully!');
//         setFormData({
//           fullName: '',
//           dateOfBirth: '',
//           className: 'PP1',
//           admissionNumber: '',
//           birthCertificateNumber: '',
//           gender: 'M',
//           parentName: '',
//           parentContact: '',
//           parentEmail: '',
//           parentId: ''
//         });
//       }
//     } catch (error) {
//       setError(error.response?.data?.message || 'Failed to register learner. Please try again.');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Container maxWidth="md">
//       <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
//         <Typography variant="h4" component="h1" gutterBottom align="center">
//           Register Learner
//         </Typography>
        
//         {error && (
//           <Typography color="error" align="center" sx={{ mb: 2 }}>
//             {error}
//           </Typography>
//         )}

//         <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
//           <TextField
//             fullWidth
//             label="Full Name"
//             name="fullName"
//             value={formData.fullName}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             fullWidth
//             label="Date of Birth"
//             name="dateOfBirth"
//             type="date"
//             InputLabelProps={{ shrink: true }}
//             value={formData.dateOfBirth}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             select
//             fullWidth
//             label="Class"
//             name="className"
//             value={formData.className}
//             onChange={handleChange}
//             margin="normal"
//             required
//           >
//             {classes.map((cls) => (
//               <MenuItem key={cls} value={cls}>
//                 {cls}
//               </MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             fullWidth
//             label="Admission Number"
//             name="admissionNumber"
//             value={formData.admissionNumber}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             fullWidth
//             label="Birth Certificate Number"
//             name="birthCertificateNumber"
//             value={formData.birthCertificateNumber}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             select
//             fullWidth
//             label="Gender"
//             name="gender"
//             value={formData.gender}
//             onChange={handleChange}
//             margin="normal"
//             required
//           >
//             <MenuItem value="M">Male</MenuItem>
//             <MenuItem value="F">Female</MenuItem>
//           </TextField>

//           <TextField
//             fullWidth
//             label="Parent Name"
//             name="parentName"
//             value={formData.parentName}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             fullWidth
//             label="Parent Contact"
//             name="parentContact"
//             value={formData.parentContact}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             fullWidth
//             label="Parent Email"
//             name="parentEmail"
//             type="email"
//             value={formData.parentEmail}
//             onChange={handleChange}
//             margin="normal"
//           />

//           <TextField
//             fullWidth
//             label="Parent ID (will be auto-assigned)"
//             name="parentId"
//             value={formData.parentId}
//             onChange={handleChange}
//             margin="normal"
//             disabled
//           />

//           <Button
//             fullWidth
//             variant="contained"
//             color="primary"
//             type="submit"
//             disabled={isLoading}
//             sx={{ mt: 3, mb: 2, height: '48px' }}
//           >
//             {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Register Learner'}
//           </Button>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default RegisterLearner;


import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Paper,
  MenuItem,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';

const classes = [
  'PG', 'PP1', 'PP2', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5',
  'Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12',
];

const RegisterLearner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const schoolId = location.state?.schoolId || auth.schoolId;

  const [formData, setFormData] = useState({
    fullName: '',
    dateOfBirth: '',
    className: 'PP1',
    stream: '',
    admissionNumber: '',
    birthCertificateNumber: '',
    gender: 'M',
    parentName: '',
    parentContact: '',
    parentEmail: '',
    parentId: '',
  });
  const [schoolStreams, setSchoolStreams] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!schoolId) {
      setError('School ID is missing. Please log in again.');
      return;
    }
    const fetchSchoolStreams = async () => {
      try {
        const response = await axios.get(`https://kidsm.vercel.app/api/schools/${schoolId}/streams`);
        if (response.data.classStreams) {
          setSchoolStreams(response.data.classStreams);
        }
      } catch (error) {
        setError('Failed to fetch school streams. Please try again.');
        console.error('Error fetching school streams:', error);
      }
    };
    fetchSchoolStreams();
  }, [schoolId]);

  useEffect(() => {
    setFormData(prev => ({ ...prev, stream: '' }));
  }, [formData.className]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!schoolId) {
      setError('School ID is missing. Please log in again.');
      return;
    }

    const hasStreams = schoolStreams[formData.className] && schoolStreams[formData.className].length > 0;
    if (hasStreams && !formData.stream) {
      setError('Please select a stream for this class.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const learnerData = {
        fullName: formData.fullName,
        dateOfBirth: new Date(formData.dateOfBirth).toISOString().split('T')[0],
        class: formData.className,
        stream: hasStreams ? formData.stream : null,
        admissionNumber: formData.admissionNumber,
        birthCertificateNumber: formData.birthCertificateNumber,
        gender: formData.gender,
        parentName: formData.parentName,
        parentContact: formData.parentContact,
        parentEmail: formData.parentEmail,
        parentId: formData.parentId || null,
        schoolId,
      };

      const response = await axios.post('https://kidsm.vercel.app/api/schools/register-learner', learnerData);
      if (response.status === 201) {
        alert('Learner registered successfully!');
        setFormData({
          fullName: '',
          dateOfBirth: '',
          className: 'PP1',
          stream: '',
          admissionNumber: '',
          birthCertificateNumber: '',
          gender: 'M',
          parentName: '',
          parentContact: '',
          parentEmail: '',
          parentId: '',
        });
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to register learner. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Register Learner
        </Typography>
        
        {error && (
          <Typography color="error" align="center" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Full Name"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Date of Birth"
            name="dateOfBirth"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={formData.dateOfBirth}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            select
            fullWidth
            label="Class"
            name="className"
            value={formData.className}
            onChange={handleChange}
            margin="normal"
            required
          >
            {classes.map((cls) => (
              <MenuItem key={cls} value={cls}>
                {cls}
              </MenuItem>
            ))}
          </TextField>
          {schoolStreams[formData.className] && schoolStreams[formData.className].length > 0 && (
            <FormControl fullWidth margin="normal">
              <InputLabel>Stream</InputLabel>
              <Select
                name="stream"
                value={formData.stream}
                onChange={handleChange}
                required
              >
                <MenuItem value="">Select Stream</MenuItem>
                {schoolStreams[formData.className].map((streamName) => (
                  <MenuItem key={streamName} value={streamName}>
                    {streamName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <TextField
            fullWidth
            label="Admission Number"
            name="admissionNumber"
            value={formData.admissionNumber}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Birth Certificate Number"
            name="birthCertificateNumber"
            value={formData.birthCertificateNumber}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            select
            fullWidth
            label="Gender"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            margin="normal"
            required
          >
            <MenuItem value="M">Male</MenuItem>
            <MenuItem value="F">Female</MenuItem>
          </TextField>
          <TextField
            fullWidth
            label="Parent Name"
            name="parentName"
            value={formData.parentName}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Parent Contact"
            name="parentContact"
            value={formData.parentContact}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Parent Email"
            name="parentEmail"
            type="email"
            value={formData.parentEmail}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Parent ID (will be auto-assigned)"
            name="parentId"
            value={formData.parentId}
            onChange={handleChange}
            margin="normal"
            disabled
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={isLoading}
            sx={{ mt: 3, mb: 2, height: '48px' }}
          >
            {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Register Learner'}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default RegisterLearner;
